import React from 'react';
import { createComponent } from '@lit-labs/react';
import { ClbToastBase as ClbToastBase_ } from '@celebration/design-system/dist/lib/toast-base';
const events = {
    onClbClickToastClose: ClbToastBase_.events
        .onClbClickToastClose,
    onClbClickToastLink: ClbToastBase_.events
        .onClbClickToastLink,
};
export const ClbToastBase = createComponent({
    tagName: ClbToastBase_.tagName,
    elementClass: ClbToastBase_,
    react: React,
    events: events,
});
//# sourceMappingURL=index.js.map